module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Resize', {
    staticClass: "app-layout",
    attrs: {
      "id": "app"
    }
  }, [_c('header-app'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(!_vm.$root.isMobile) ? _c('transition-group', {
    attrs: {
      "name": "page"
    },
    on: {
      "enter": _vm.enter
    }
  }, [(_vm.$route.name == 'Main') ? _c('Main', {
    key: 1
  }) : _vm._e(), _vm._v(" "), (_vm.$route.name == 'Country') ? _c('Country', {
    key: 2
  }) : _vm._e()], 1) : _c('div', [(_vm.$route.name == 'Main') ? _c('Main') : _vm._e(), _vm._v(" "), (_vm.$route.name == 'Country') ? _c('Country') : _vm._e()], 1)], 1), _vm._v(" "), _c('footer-app', {
    class: {
      'footer-white-color': !_vm.GET_LOAD && _vm.$route.name != 'Country'
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dced5584","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 507
// module chunks = 1